import React from 'react'
import SignOut from '.';
import { SignOutActions } from '../../../../store';
import {connect} from 'react-redux';
import {Logout} from 'react-cognito';

class SignOutContainer extends React.Component {
  render() {
    return (
      <Logout>
      <SignOut {...this.props}/>
      </Logout>
    )
  }
}
const mapDispatchToProps = (dispatch,ownProps) => {
  return{
    //signOut:(cognitoId,tokens)=> SignOutActions.signOut(cognitoId,tokens,dispatch),
    signOutUser:()=> SignOutActions.signOut(dispatch),
  }
}
const mapStateToProps = (state, ownProps) => {
    return {
        user:state.cognito.user,
        loginState:state.cognito.state,
    }
}
export default (connect(mapStateToProps,mapDispatchToProps)(SignOutContainer));